import React from "react";
import logger from "../../utils/LoggerFrontend";

import * as sc from "./MetricsReport.styled";
import TabCreativesPerformanceReport from "../../PagesAdmin/AdminPanel/CreativesPerformanceTableReport";
import { FunnelChart } from "../../PagesUser/Campaign/DataVisualization/Charts/FunnelChart/FunnelChart.jsx";
import { recruitmentDataTransform } from "../../PagesUser/Campaign/DataVisualization/Charts/FunnelChart/FunnelChart.utils";
import { css } from "styled-components";
import { PieChartLegend } from "../../PagesUser/Campaign/DataVisualization/Charts/PieChart/PieChartLegend.jsx";
import { withRouter } from "react-router-dom";
import withRefluxStore from "../../Stores/withRefluxStore.jsx";
import { Store__System } from "@talentbait/shared-components";
import {
  platformDataTransform,
  ratingsDataTransform
} from "../../PagesUser/Campaign/DataVisualization/Charts/PieChart/PieChart.utils.js";
import { useEnrichedData } from "../../hooks/use-enriched-data.hook.js";

const styling = css`
  max-width: 800px;
`;

// campaign/report/:orgaId/:id
const MetricsReport = ({ match, userProfile }) => {
  const { id: campaignId } = match.params;
  const creationDate = new Date().toLocaleString("de");

  logger.log("CampaignRead:MetricsReport", "MetricsReport", { campaignId, creationDate });
  const metrics = useEnrichedData(campaignId);

  logger.log("CampaignRead:MetricsReport", "metrics data", { metrics });

  if (!metrics) {
    return null;
  }

  const {
    channelMetrics,
    campaignData,
    bewerberMetrics,
    platformBreakdown,
    statusBreakdown = {},
    ratingsBreakdown = [],
    averageRating,
    channelCampaigns,
    laufzeit,
    locations,
    showCreativeTable = false
  } = metrics || {};

  const isCampaingFinished = campaignData?.status === "FINISHED";

  const includesFbOrInstagramChannels = channelCampaigns?.find((cc) => {
    let includes = false;
    if (cc.channel === "facebook" || cc.channel === "instagram") {
      includes = true;
    }
    return includes;
  });

  logger.log("CampaignRead:MetricsReport", "metrics, goal and creative flag", {
    metrics,
    campaignGoal: campaignData?.campaignGoal,
    showCreativeTable,
    statusBreakdown,
    platformBreakdown
  });

  const campaignGoalIsApplicants = campaignData?.campaignGoal === "applicants";
  const statuses = Object.values(statusBreakdown)?.[0] || [];
  const platforms = Object.values(platformBreakdown)?.[0] || [];
  const totalCandidates = platforms?.reduce((sum, item) => sum + item?.value || 0, 0);

  return (
    <sc.MainWrapper>
      <sc.Header>
        <sc.Title>Social Media Campaign</sc.Title>
        <sc.SubTitle>Auswertung</sc.SubTitle>
        <sc.Date>{laufzeit}</sc.Date>
        <sc.Date>Erstellungsdatum des Berichts: {creationDate}</sc.Date>
        <sc.Logo src="../../../images/talentbait-logo.svg" />
      </sc.Header>

      <sc.CampaignInformation>
        <sc.Stellentitel>STELLENTITEL</sc.Stellentitel>
        <sc.JobTitle>{campaignData.campaignName}</sc.JobTitle>
        <sc.CampaignName>{campaignData.companyName}</sc.CampaignName>
      </sc.CampaignInformation>

      <sc.CampaignMetrics>
        <sc.CampaignLocation>Standorte: {locations}</sc.CampaignLocation>
        <sc.Anzeigenlink>
          Anzeigenlink: <sc.Link>{campaignData.jobPostingUrl}</sc.Link>
        </sc.Anzeigenlink>
      </sc.CampaignMetrics>

      {Object.keys(channelMetrics).map((channel) => {
        return (
          <sc.Channel key={channel}>
            <h2 className={channel}>{channel.charAt(0).toUpperCase() + channel.slice(1)}</h2>

            <sc.ChannelMetric>
              {channelMetrics[channel].map(({ label, value }) => {
                return (
                  <sc.Box key={label}>
                    <span>{value}</span>
                    <span>{label}</span>
                  </sc.Box>
                );
              })}
            </sc.ChannelMetric>
          </sc.Channel>
        );
      })}

      {(campaignGoalIsApplicants || showCreativeTable) && (
        <div>
          {Object.keys(bewerberMetrics).map((channel) => {
            return (
              <sc.Channel key={channel}>
                <h2>{channel}</h2>

                <sc.Group>
                  {ratingsBreakdown.length > 0 && (
                    <PieChartLegend
                      arrayData={ratingsBreakdown}
                      language={userProfile?.language}
                      averageRating={averageRating}
                      transformFunc={ratingsDataTransform}
                      styling={styling}
                    />
                  )}
                  <sc.ChannelMetric>
                    {bewerberMetrics[channel].map(({ label, value }) => {
                      return (
                        <sc.Box key={label}>
                          <span>{label}</span>
                          <span>{value}</span>
                        </sc.Box>
                      );
                    })}
                  </sc.ChannelMetric>
                </sc.Group>
              </sc.Channel>
            );
          })}

          {Array.isArray(statuses) &&
            statuses.length > 0 &&
            Object.keys(statusBreakdown).map((status) => {
              return (
                <sc.Channel key={status}>
                  <h2>{status}</h2>
                  <sc.Group>
                    {campaignGoalIsApplicants && (
                      <FunnelChart
                        title="Bewerbungsprozess-Trichter"
                        arrayData={statuses}
                        transformFunc={recruitmentDataTransform}
                        styling={styling}
                      />
                    )}
                    <sc.StatusBox>
                      {statusBreakdown[status].map(({ label, value }) => {
                        return (
                          <sc.StatusBoxContent key={label}>
                            <span>{label}</span>
                            <span>{value}</span>
                          </sc.StatusBoxContent>
                        );
                      })}
                    </sc.StatusBox>
                  </sc.Group>
                </sc.Channel>
              );
            })}

          {Array.isArray(platforms) &&
            platforms.length > 0 &&
            Object.keys(platformBreakdown).map((platform) => {
              return (
                <sc.Channel key={platform}>
                  <h2>{platform}</h2>
                  <sc.Group>
                    <PieChartLegend
                      arrayData={platforms}
                      language={userProfile?.language}
                      totalAmount={totalCandidates}
                      transformFunc={platformDataTransform}
                      styling={styling}
                    />
                    <sc.StatusBox>
                      {platformBreakdown[platform].map(({ label, value }) => {
                        return (
                          <sc.StatusBoxContent key={label}>
                            <span>{label.charAt(0).toUpperCase() + label.slice(1)}</span>
                            <span>{value}</span>
                          </sc.StatusBoxContent>
                        );
                      })}
                    </sc.StatusBox>
                  </sc.Group>
                </sc.Channel>
              );
            })}

          <sc.CreativesWrapper>
            {includesFbOrInstagramChannels ? (
              <sc.CreativeMetrics id="creativeMetrics">
                <h2>Auswertung der Bildmetriken</h2>

                <TabCreativesPerformanceReport
                  channelCampaigns={channelCampaigns}
                  isCampaingFinished={isCampaingFinished}
                  campaignData={campaignData}
                />
              </sc.CreativeMetrics>
            ) : (
              <>
                <div id="creativeMetrics">
                  <sc.NoFacebookInstagramChannelTitle>
                    Keine Metriken vorhanden
                  </sc.NoFacebookInstagramChannelTitle>

                  <sc.NoFacebookInstagramChannel>
                    Aktuell werden nur Bildmetriken ausgewiesen, wenn Facebook und oder Instagram
                    als Kanäle innerhalb der Kampagne vertreten sind. Für alle weiteren Kanäle sind
                    zurzeit keine Bildmetriken verfügbar.
                  </sc.NoFacebookInstagramChannel>
                </div>
              </>
            )}
          </sc.CreativesWrapper>
        </div>
      )}
    </sc.MainWrapper>
  );
};

export default withRouter(withRefluxStore(MetricsReport, [Store__System], ["userProfile"]));
